<section
  class="hero"
  id="hero"
  [class.hero--custom-bg]="profile()?.heroImageUrl"
  [style.background-image]="heroBackground()">
  <div class="hero__overlay"></div>
  <div class="hero__content container">
    <span class="hero__subtitle">Pákozd, a Velencei-tó partján</span>
    <h1 class="hero__title">
      <span class="brand-name">{{ profile()?.headline || profile()?.name || 'Kanyar Büfé' }}</span>
    </h1>
    <p class="hero__description">
      {{
        profile()?.descriptionPrimary ??
          'A Velencei-tó partján, Pákozdon várunk: házias pacalpörkölt, hagyományos magyar fogások és válogatott cseh csapolt sörök, minőségi alapanyagokból.'
      }}
    </p>
    <div class="hero__actions">
      @if (showReservation()) {
        <a class="btn-primary" (click)="scrollTo('reservation')">Asztalfoglalás</a>
      }
      <a class="btn-outline" (click)="scrollTo('menu')">Étlap megtekintése</a>
    </div>
  </div>
  <div class="hero__scroll-indicator">
    <span></span>
  </div>
</section>
